<!--
This component provides the proper navigation layout base on screen size.
-->
<template>
  <div>
    <!-- Visible on mobile -->
    <div v-responsive.sm.xs>
      <mobileNav/>
    </div>
    <!-- Visible on tablet desktop -->
    <div v-responsive.lg.xl.md>
      <sidebar/>
    </div>
  </div>
</template>

<script>
import '@/assets/styles/dashboard.css'

// import DashboardTopBar from '@/components/dashboard/DashboardTopBar'
import DashboardMobileNav from '@/components/common/DashboardMobileNav'

import Sidebar from '@/containers/dashboard/Sidebar'

export default {
  name: 'dashboard-nav',
  components: {
    sidebar: Sidebar,
    mobileNav: DashboardMobileNav
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/DashboardNav.vue